import { render, staticRenderFns } from "./BookmarkToggle.vue?vue&type=template&id=1538a528&scoped=true&"
import script from "./BookmarkToggle.vue?vue&type=script&lang=js&"
export * from "./BookmarkToggle.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkToggle.vue?vue&type=style&index=0&id=1538a528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538a528",
  null
  
)

export default component.exports